import { render, staticRenderFns } from "./DevBpbjInfoForm.vue?vue&type=template&id=d77374d6&"
import script from "./DevBpbjInfoForm.vue?vue&type=script&lang=js&"
export * from "./DevBpbjInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports